import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiHelperService } from '../../core/api-helper.service';
import { Invoice, InvoiceStatus } from './invoice.model';

@Injectable({
    providedIn: 'root'
})
export class InvoiceService {

    constructor( private apiHelper: ApiHelperService) { }

    private options = { authenticate: true, setRoot: true };

    getAllInvoices(): Promise<Invoice[]> {
        const headers: HttpHeaders = this.apiHelper.getDefaultHeaders();
        return this.apiHelper.apiCallSane('/invoices', 'GET', headers, null, null)
            .then((inv: Partial<Invoice>[]) => inv.map(i => new Invoice(i)));
    }

    async getInvoiceById(id: string): Promise<Invoice> {
        return this.apiHelper.apiCallSane(
            '/invoice',
            'GET',
            this.apiHelper.getDefaultHeaders(),
            { id },
            null,
            this.options
        );
    }

    getInvoicesBySubId(subscriptionId: string): Promise<Invoice[]> {
        const headers: HttpHeaders = this.apiHelper.getDefaultHeaders();
        return this.apiHelper.apiCallSane(
            '/invoices',
            'GET',
            headers,
            { subscriptionId },
            null,
            this.options
        );
    }

    markAsUncollectible(id: string): Promise<void> {
        const headers: HttpHeaders = this.apiHelper.getDefaultHeaders();
        return this.apiHelper.apiCallSane(
            '/invoice',
            'PATCH',
            headers,
            { id },
            { status: InvoiceStatus.UNCOLLECTIBLE },
            this.options
        );
    }

    markAsPaidOutsideSystem(id: string, amount: number): Promise<void> {
        const headers: HttpHeaders = this.apiHelper.getDefaultHeaders();
        return this.apiHelper.apiCallSane(
            '/invoice/pay-outside-system',
            'POST',
            headers,
            { id },
            { amount },
            this.options
        );
    }

    addComplementaryCredits(id: string, count: number) {
        const headers: HttpHeaders = this.apiHelper.getDefaultHeaders();
        return this.apiHelper.apiCallSane(
            '/invoice/add-complementary-credits',
            'POST',
            headers,
            { id },
            { count }
        );
    }

    manuallyPayInvoiceWithSaved(id:string, amount: number) {
        return this.apiHelper.apiCallSane(
            '/invoice/pay',
            'POST',
            this.apiHelper.getDefaultHeaders(),
            { id },
            { amount },
            this.options
        );
    }
}
